export function splitHost(
  hostname: string
): { label: string; parent: string } | null {
  const i = hostname.indexOf(".");
  if (i <= 0 || i >= hostname.length - 1) return null;
  return { label: hostname.slice(0, i), parent: hostname.slice(i + 1) };
}

export function splitCombinedSpaceTenantLabel(
  label: string
): { spaceLabel: string; tenantLabel: string } | null {
  const separator = label.indexOf("--");
  if (separator <= 0) return null;
  const tenantLabel = label.slice(separator + 2);
  if (!tenantLabel) return null;
  return { spaceLabel: label.slice(0, separator), tenantLabel };
}
